import { setEndOfDay, setStartOfDay } from "../../utils/date_util";
export function eventBlockDateEventRangeValidator($el) {
  const eventForm = $el.closest("form")[0];
  const datepickerContainer = $el.closest(".event-block__date")[0];
  const eventStartAtInputValue = eventForm.querySelector('input[name*="offer_event[start_date]"]').value;
  const eventEndAtInputValue = eventForm.querySelector('input[name*="offer_event[end_date]"]').value;
  const currentEventBlockDateInputValue = datepickerContainer.querySelector('input[id*="_at_date"]').value;
  const currentEventBlockTimeInputValue = datepickerContainer.querySelector('input[id*="_at_time"]').value;
  if (!currentEventBlockDateInputValue || !currentEventBlockTimeInputValue || !eventStartAtInputValue || !eventEndAtInputValue) {
    return true;
  }
  const eventStartAt = setStartOfDay(new Date(eventStartAtInputValue));
  const eventEndAt = setEndOfDay(new Date(eventEndAtInputValue));
  const currentBlockDate = new Date(datepickerContainer.querySelector("label input").value);
  return currentBlockDate >= eventStartAt && currentBlockDate <= eventEndAt;
}
Foundation.Abide.defaults.validators["event_block_date_event_range"] = eventBlockDateEventRangeValidator;
